import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import VueScrollTo from "vue-scrollto";
import Meta from "vue-meta";
import { filters, plugins } from "@vg-faset/core";
import "@/styles/cert-layer-overrides.scss";
import utilities from "@/services/utility.service.js";

Vue.config.productionTip = false;

Vue.use(filters);
Vue.use(VueScrollTo);
Vue.use(Meta);
Vue.use(plugins.smartFocusPlugin);

Vue.filter("toFixed", function (value, decimals) {
	return utilities.toFixed(value, decimals);
});

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount("#app");
